<script>
    import { keyScope } from '../scripts/keyboard';
    import ActionButton from './components/ActionButton.svelte';
    import PlaygroundFeatureList from './components/PlaygroundFeatureList.svelte';
    import PlaygroundPhotoGallery from './components/PlaygroundPhotoGallery.svelte';
    import PopupHeader from './components/PopupHeader.svelte';
    import ApiClient from '../scripts/apiclient';
    import { createActionRunner } from '../scripts/ActionRunner';

    const { busy, run } = createActionRunner();

    export let edit;
    $: playground = edit.playground;

    export let closePopup;

    const approve = run(() => ApiClient.approveEdit(edit).then(close));

    const reject = run(() => ApiClient.rejectEdit(edit).then(close));

    function cancel() {
        close();
    }

    // Closing is possible while an action is running, so that a hanging action can be
    // abandoned and retried. The flag makes sure that an action finishing after that
    // doesn't close the popup a second time, closing whatever has been opened since.
    let closed = false;

    function close() {
        if (closed || !closePopup) {
            return;
        }

        closed = true;
        closePopup();
    }

    keyScope({ Enter: approve, Escape: cancel, a: reject }, { modal: true });
</script>

<div class="dialog">
    <PopupHeader {playground} />

    {#if playground.description}
        <p>{playground.description}</p>
    {/if}

    {#if playground.food}
        <p class="tight">Mat: {playground.food}</p>
    {/if}

    {#if playground.toilet}
        <p class="tight">Toalett: {playground.toilet}</p>
    {/if}

    {#if playground.directions}
        <p class="tight">Ta sig hit: {playground.directions}</p>
    {/if}

    {#if playground.parking}
        <p class="tight">Parkering: {playground.parking}</p>
    {/if}

    {#if playground.recommended}
        <p class="recommended">Rekommenderad</p>
    {/if}

    {#if playground.features && playground.features.length > 0}
        <div class="list-wrapper">
            <PlaygroundFeatureList features={playground.features} />
        </div>
    {/if}

    <PlaygroundPhotoGallery {playground} readonly />

    <div class="removal-reason">
        <strong>Anledning:</strong> {edit.metadata.reason || '(Ingen anledning angiven)'}
    </div>

    <div class="button-wrapper">
        <button class="btn btn-sm" on:click={cancel}>Avbryt</button>
        <ActionButton {busy} action={reject} variant="btn-warning" title="Avslå förslaget"><u>A</u>vslå</ActionButton>
        <ActionButton {busy} action={approve} variant="btn-danger" title="Godkänn borttagning">Ta bort lekplats</ActionButton>
    </div>
</div>

<style>
    /* No width of its own. This used to be held at 500px, which the dialog then had to be
       at least as wide as whatever the screen was. The width is the popup's to decide now,
       between the floor and ceiling it is bound with, both of which know how much screen
       there is. */
    .dialog {
        height: 100%;
    }

    .list-wrapper {
        margin: 10px 0 7px 0;
    }

    p.tight {
        margin: 5px 0;
    }

    .removal-reason {
        background: #fff3cd;
        border: 1px solid #ffc107;
        border-radius: 4px;
        padding: 8px 12px;
        margin: 10px 0;
    }

    .button-wrapper {
        margin-top: 15px;
        text-align: right;
    }
</style>
